import React from 'react'
import { Link } from '@tanstack/react-router'
import { ColumnDef } from '@tanstack/react-table'
import type { PositionedBannerResponse } from 'api/generated'
import { Button } from 'components/ui/button'
import { isBannerManager } from './authentication'

export interface BannersColumnsProps {
  onDeleteBanner: (id: number) => void
}

export const bannersColumns = (
  props: BannersColumnsProps
): ColumnDef<PositionedBannerResponse>[] => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) => <div>{getValue() as React.ReactNode}</div>, // Simple text display
  },
  {
    accessorKey: 'slot',
    header: 'Slot',
  },
  {
    accessorKey: 'type',
    header: 'Banner',
    cell: ({ row }) =>
      row.original.bannerable_id != null ? (
        <Link
          to='/custom-banner/$id/modifica'
          params={{ id: row.original.bannerable_id.toString() }}
        >
          {row.getValue('type')}
        </Link>
      ) : (
        <div>{row.getValue('type')}</div>
      ),
  },
  {
    accessorKey: 'id', // Reusing 'id' as a key for actions
    header: 'Azioni',
    cell: ({ row }) => {
      const handleDelete = () => {
        if (window.confirm('Sei sicuro di voler eliminare questo banner?')) {
          props.onDeleteBanner(row.original.id)
        }
      }

      return (
        <div className='flex items-center gap-2'>
          <Link
            to='/gestione-banner/$id/modifica'
            params={{ id: row.original.id.toString() }}
          >
            Modifica
          </Link>
          {!isBannerManager() && (
            <Button size='sm' variant='destructive' onClick={handleDelete}>
              Elimina
            </Button>
          )}
        </div>
      )
    },
  },
]
